export const RefillOrder = () => <span className="bg-orange-200 text-orange-600 font-semibold text-[12px] p-1 rounded-[2px]">Refill</span>

export const NewOrder = () => <span className="bg-green-200 text-green-600 font-semibold text-[12px] p-1 rounded-[2px]">New</span>